export default __webpack_public_path__ + "static/media/new_profile.e7d079a9.svg";